import { __rest } from 'tslib';
import React from 'react';
import { isNumber, isString } from '@10d/tend-ui-utils';
import { useTheme, useColor } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root, Content, Bubble } from './styled.js';

const clamp = (value, max) => (value >= max ? `${max}+` : value);
const BaseCounter = (_a, ref) => {
    var { showZero = false, preset = 'red', before, after, children, inner, max = 99, offset = [0, 0], placement = 'rightTop', className, rootClassName, inline = true, color, backgroundColor } = _a, props = __rest(_a, ["showZero", "preset", "before", "after", "children", "inner", "max", "offset", "placement", "className", "rootClassName", "inline", "color", "backgroundColor"]);
    const theme = useTheme();
    const _color = useColor(color);
    // FIXME: Поправить типы
    const _backgroundColor = useColor(backgroundColor);
    const isInnerReactElement = React.isValidElement(inner);
    const isInnerNumber = isNumber(inner);
    const isInnerString = isString(inner);
    const title = isInnerNumber ? `${inner}` : undefined;
    const isPositiveNumber = isInnerNumber && inner > 0;
    const isAllowedNumber = isInnerNumber && showZero && inner >= 0;
    const isShown = isInnerReactElement || isPositiveNumber || isAllowedNumber || isInnerString;
    const content = isInnerNumber ? clamp(inner, max) : inner;
    return (React.createElement(Root, { ref: ref, theme: theme, className: cn(['tend-ui-counter-root', rootClassName]) },
        before && (React.createElement(Content, { className: 'tend-ui-counter-before', theme: theme }, before)),
        children,
        isShown && (React.createElement(Bubble, Object.assign({ "data-testid": 'tend-ui-counter' }, props, { theme: theme, "$inline": inline, "$color": _color, "$backgroundColor": _backgroundColor, "$preset": preset, "$offset": offset, "$placement": placement, "$pointer": !!props.onClick, title: title, className: cn(['tend-ui-counter-counter', className]) }), content)),
        after && (React.createElement(Content, { className: 'tend-ui-counter-after', theme: theme }, after))));
};
const Counter = React.forwardRef(BaseCounter);
Counter.displayName = 'Counter';

export { Counter };
//# sourceMappingURL=Counter.js.map
